<div>
    <h5 mat-dialog-title class="modal_title text-[#0b0b13] text-[15px] leading-normal font-medium mt-0 flex w-full">
        {{_prospectStatusSer?.typeOf == 'add' ? ('SETTING_PAGE.ADD_NEW_PROSPECT_STATUS' | translate) : ('SETTING_PAGE.EDIT_PROSPECT_STATUS' | translate)}}
        <i class="ri-close-fill ml-auto text-[22px] leading-none cursor-pointer font-medium text-[#0b0d13]"
            mat-dialog-close></i>
    </h5>
    <form [formGroup]="_prospectStatusSer?.prospectStatusForm" autocomplete="off">
        <mat-dialog-content class="modal_body">
            <div class="mail-name-input form-group relative mb-4">
                <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic" floatLabel="always">
                    <mat-label class="form_label">{{"SETTING_PAGE.STATUS_NAME" | translate}}</mat-label>
                    <input type="text" id="name" required class="w-full form_input rounded-3" [autofocus]
                        [placeholder]="'SETTING_PAGE.ENTER_STATUS_NAME' | translate" formControlName="name" matInput />
                    <mat-error *ngIf="_prospectStatusSer?.prospectStatusForm?.get('name')?.touched && _prospectStatusSer?.prospectStatusForm?.get('name')?.errors?.required">{{"EMAIL_MARKETING.FIELD_REQUIRED" | translate}}</mat-error>
                    <mat-hint class="mat-error"
                        *ngIf="_prospectStatusSer?.prospectStatusForm?.controls?.name?.errors?.lv">{{_prospectStatusSer?.prospectStatusForm?.controls?.name?.getError("lv")}}</mat-hint>
                </mat-form-field>
            </div>
            <div class="mail-name-input form-group relative mb-4">
                <div>
                    <mat-label class="text-[#0b0d13] font-normal text-base leading-[18px]"
                        (click)="interestedStatus.open()">
                        {{"SETTING_PAGE.INTERESTED_STATUS" | translate}}
                    </mat-label>
                    <mat-form-field class="w-full fuse-mat-dense mt-[3px]" subscriptSizing="dynamic"
                        floatLabel="always">
                        <mat-select #interestedStatus formControlName="interested_status" name="interested_status" [placeholder]="'SETTING_PAGE.SELECT_STATUS' | translate">
                            <mat-option class="min-h-[38px]" [value]="'Positive'">{{"SETTING_PAGE.POSITIVE" | translate}}</mat-option>
                            <mat-option class="min-h-[38px]" [value]="'Negative'">{{"SETTING_PAGE.NEGATIVE" | translate}}</mat-option>
                            <mat-option class="min-h-[38px]" [value]="'Neutral'">{{"SETTING_PAGE.NEUTRAL" | translate}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="_prospectStatusSer?.prospectStatusForm?.get('interested_status')?.touched && _prospectStatusSer?.prospectStatusForm?.get('interested_status')?.errors?.required">{{"EMAIL_MARKETING.FIELD_REQUIRED" | translate}}</mat-error>
                        <mat-hint class="mat-error"
                            *ngIf="_prospectStatusSer?.prospectStatusForm?.controls?.interested_status?.errors?.lv">{{_prospectStatusSer?.prospectStatusForm?.controls?.interested_status?.getError("lv")}}</mat-hint>
                    </mat-form-field>
                </div>
            </div>
            <div class="relative">
                <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic">
                    <mat-label for="status_color"
                        class="form_label font-normal text-[#0B0D13] leading-[18px] text-base mb-[5px]">
                        {{"SETTING_PAGE.STATUS_COLOR" | translate}}
                    </mat-label>
                    <input matInput type="text" name="status_color" formControlName="color" class="form_input w-full"
                        id="status_color" readonly />
                    <mat-error *ngIf="_prospectStatusSer?.prospectStatusForm?.get('color')?.touched && _prospectStatusSer?.prospectStatusForm?.get('color')?.errors?.required">{{"EMAIL_MARKETING.FIELD_REQUIRED" | translate}}</mat-error>
                    <mat-hint class="mat-error"
                        *ngIf="_prospectStatusSer?.prospectStatusForm?.controls?.color?.errors?.lv">{{_prospectStatusSer?.prospectStatusForm?.controls?.color?.getError("lv")}}</mat-hint>
                </mat-form-field>
                <span class="rounded-[4px] h-[30px] absolute right-[6px] top-[29px]"
                    [style.background]="_prospectStatusSer?.prospectStatusForm?.value?.color" [cpPosition]="'bottom'"
                    [cpOutputFormat]="'hex'" [(colorPicker)]="_prospectStatusSer.statusColor"
                    (colorPickerChange)="changeColor($event)"><mat-icon class="w-[49px]"></mat-icon>
                </span>
            </div>
        </mat-dialog-content>
    </form>
    <mat-dialog-actions align="start" class="form_action">
        <btn-loading type="submit" color="primary" [loading]="isaddEditStatus" (click)="addUpdateProspectStatus()"
            btnClass="text-custom text-md font-medium leading-[14px] min-h-[34px] max-h-[34px] rounded">{{_prospectStatusSer?.typeOf == 'add' ? ("GENERAL.ADD" |
            translate) : ('CAMPAIGN.UPDATE' | translate)}}</btn-loading>
        <button matRipple class="cancel_btn" mat-dialog-close>{{
            "GENERAL.CANCEL" | translate
            }}</button>
    </mat-dialog-actions>

</div>